export const TrustedErrors = [
  "Something went wrong. Please try again.",
  "Your third party account is already linked to an existing Hi-Rez Studios account.",
  "Your steam account is already linked to an existing Hi-Rez Studios account.",
  "We were unable to retrieve your Steam details. Please try again.",
  "We were unable to retrieve your Facebook details. Please try again.",
  "We were unable to retrieve your Google details. Please try again.",
  "We were unable to retrieve your Playstation details. Please try again.",
  "We were unable to retrieve your Xbox details. Please try again.",
  "We were unable to retrieve your Nintendo details. Please try again.",
  "Unsupported action type for service Twitch. Please try again with a supported action type.",
  "Unable to retrieve your Twitch details. Please try again.",
  "Unsupported action type for service Mixer. Please try again with a supported action type.",
  "Unable to retrieve your Mixer details. Please try again.",
  "Unable to retrieve your Discord details. Please try again.",
  "Unable to retrieve your Epic details. Please try again.",
  "Unsupported action type for service Amazon. Please try again with a supported action type.",
  "Unable to retrieve your Amazon details. Please try again.",
];



// WEBPACK FOOTER //
// ./components/error-handling/trustedErrors.js